import React from 'react';
import Buttons from 'ap-admin-components/lib/Components/Buttons';
import Button from 'ap-admin-components/lib/Components/Button';
import Well from 'ap-admin-components/lib/Components/Well';
import { useTranslation } from 'next-i18next';
import { translationNamespace } from '@/lib/config';
import styles from './styles.module.scss';

interface IProps {
  onLogin: () => void;
  hasError?: boolean;
}

const Login: React.FC<IProps> = ({ onLogin, hasError }) => {
  const { t } = useTranslation(translationNamespace);
  return (
    <Well theme="centered">
      <h1 className={styles['login__header']}>{t('title')}</h1>
      <Buttons layout="centered">
        <Button
          title={t('login.go')}
          intent="primary"
          onClick={onLogin}
        />
      </Buttons>
      {hasError && <p className={styles['login__error']}>{t('login.error')}</p>}
    </Well>
  );
};

export default Login;
